import React from 'react';
import SupplierRedemptionCard from './components/SupplierRedemptionIndex.jsx';

const SupplierRedemption = () => <SupplierRedemptionCard />;

export default SupplierRedemption;
